export default __webpack_public_path__ + "static/media/legacy_system_img.c11402fe.svg";